export const RuleEngineServiceName = 'RuleEngineService';

export const SystemServiceNames = [RuleEngineServiceName] as const;

/**
 * `GET /users/:gid` is served with a long `Cache-Control: max-age`, so an updated user would keep being replayed
 * from the browser cache. Varying the URL with a token that is generated once per application load makes every
 * reload fetch fresh data, while repeated lookups within the same session are served by {@link CacheService}.
 */
export const CACHE_BUSTER_PARAM = 'v';

export const cacheBuster = Date.now().toString(36);

export const SETTINGS_CACHE_KEY = 'me-settings';
